import React, { useState } from "react";
import { Calendar } from "lucide-react";
import { Audience, AudienceRowProps } from "../../../components/marketing/audience/type";
import { initialAudiences } from "./data";
import { SearchBar } from "../../../components/marketing/audience/searchbar";

const Header: React.FC = () => (
  <div className="flex items-center justify-between mb-6">
    <div>
      <h1 className="text-3xl font-semibold text-gray-900 dark:text-gray-100">Audiences</h1>
      <p className="text-sm text-gray-600 dark:text-gray-400">Real-time</p>
    </div>
    <button className="text-sm text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200">Help</button>
  </div>
);

// Table Header Component
const TableHeader: React.FC = () => (
  <div className="grid grid-cols-4 gap-4 px-6 py-3 bg-gray-50 dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 text-base font-medium text-gray-700 dark:text-gray-300">
    <div className="">Name</div>
    <div className=" text-left">Size</div>
    <div className="">Status</div>
    <div className=" text-right">Updated</div>
  </div>
);

const AudienceRow: React.FC<AudienceRowProps> = ({ audience }) => (
  <div className="grid grid-cols-4 text-base gap-4 px-6 py-4 border-b border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors">
    <div className="font-medium text-gray-900 dark:text-gray-100">{audience.name}</div>
    <div className=" text-left text-gray-700 dark:text-gray-300">
      {audience.size.toLocaleString()}
    </div>
    <div className="">
      <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-base bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-400">
        {audience.status}
      </span>
    </div>
    <div className="text-right text-gray-500 dark:text-gray-400 flex items-center justify-end gap-1">
      <Calendar className="w-4 h-4" />
      {audience.updated}
    </div>
  </div>
);

const AudienceDashboard: React.FC = () => {
  const [audiences] = useState<Audience[]>(initialAudiences);
  const [searchTerm, setSearchTerm] = useState("");

  const filteredAudiences = audiences.filter((audience) =>
    audience.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="max-w-7xl mx-auto p-6">
        <Header />
        <SearchBar searchTerm={searchTerm} onSearch={setSearchTerm} />

        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700">
          <TableHeader />
          <div>
            {filteredAudiences.map((audience) => (
              <AudienceRow key={audience.id} audience={audience} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AudienceDashboard;
